// (Ryan - 2/4/2021) This seems like the wrong place for this
// this looks like team project specific data but it is used in userUtils.
// But where it's used in user utils also looks like team project specific
// imo, both should be moved
export const teamAdminPermissionOptions = [
  { label: '---', value: '' },
  { label: 'All Access', value: 'All Access' },
  { label: 'Staff', value: 'Staff' },
  { label: 'Communications', value: 'Communications' },
  { label: 'Basic', value: 'Basic' }
];

export const ROLE = Object.freeze({
  // AKA Site Admin
  standardAdmin: '892EB939-0126-4686-8286-63CA3002BAC7',
  // AKA School Admin
  athleticDirector: '8D4DBD96-D586-4A26-A7CF-3560DEEEBCCA',
  // AKA State Association Admin
  associationAdministrator: 'A187FB6C-CEDA-46B2-8DD7-69722AA61821',
  // AKA Head Coach
  teamAdministrator: '5174FFB7-004E-47CD-AD72-92A1F6B2630A',
  teamCommunity: '150DD0CB-34C3-4763-B475-C7722F2E9AED',
  statSupplier: 'E8AAAC3A-B3A7-487A-9CC0-989FC9531278',
  photographer: '179D0EA7-74CF-42E1-A7EF-591B3AEAA7A9',
  writer: '9A8364E0-BB77-46E2-B0BD-6AC1009C9BBA',
  tournamentDirector: '401D67AC-AC9B-49C2-91F4-1BA92BD1153B',
  meetManager: 'C3F572E3-7679-415F-84BA-A5D7CEFE697B',
  career: '35d1ca54-4ca9-4c17-81a5-70fde642d3a1'
});

export const PERMISSION = Object.freeze({
  coachAllAccess: '20B19769-89E9-45D3-947D-95FCFE3AD4DC',
  coachData: 'B1B50AC7-56C2-4CEE-B177-E6EAE284817F',
  coachCommunications: 'A80C8E18-F4E0-46C8-A509-6D47489D512D',
  coachOtr: 'AB1017DA-4E94-4DE8-8FF2-798DFDC4020B',
  teamCommunityBasic: '864CEF22-326C-4380-BF5B-3728D57BA6C2',
  careerAthlete: 'd400ab66-af4d-40b8-aa2b-f3c8be736446',
  careerParent: 'd2495e20-0c41-4409-8811-c85b360ad96e'
});
